import { ElementController } from 'js-common';

import { MESSAGES_CONTROLLER_ID } from './constants';

/**
 * Controller for Django messages.
 */
export default class Messages extends ElementController {
  static id = MESSAGES_CONTROLLER_ID;

  /**
   * DOM ready.
   */
  init() {
    this.on(this.root, 'click', 'button', this.handleCloseClick);
  }

  /**
   * Remove the message node when the close button is clicked.
   *
   * @param {Event} e - Click event.
   */
  handleCloseClick = (e) => {
    e.currentTarget.closest('li').remove();
  };
}
